//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Button, Typography } from '@mui/material'
import React, { ReactElement } from 'react'

import { useOtDispatch, useOtSelector } from '@react/redux/store'

import { EthAddr } from '@shared/SchemaTypes'
import { PoolFlexOverviewCTO, PoolFlexOverviewCTOSchema } from '@shared/sharedTypes'
import { ETH_ADDR_ZERO } from '@shared/SchemaTypes'
import ViewField from '@react/components/elements/ViewField'
import { theme } from '@react/components/theme'
import { dailyInterestAccrualForFlexTx } from '@react/signedTxs/dailyInterestAccuralForFlexTx'

export default function AdminDailyAccrualForm(props: { poolAddr: EthAddr }): ReactElement {
  const { poolAddr } = props
  const dispatch = useOtDispatch()

  const poolOverviewCTO = useOtSelector(
    (state) => state.poolState.poolOverviewCTOs[poolAddr ?? ETH_ADDR_ZERO] as PoolFlexOverviewCTO
  )
  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const sx = {
    backgroundColor: theme.palette.fg.main,
    color: '#FFFFFF',
    padding: '11px 16px 11px 16px',
    borderRadius: '6px',
    marginTop: '8px',
  }

  const handleDailyAccrual = (): void => {
    setIsSubmitted(true)

    dispatch(
      dailyInterestAccrualForFlexTx({
        poolAddr,
      })
    )

    const event = new Event('modalClose')
    window.dispatchEvent(event)
  }

  return (
    <div data-testid="admin-wthdrawal-form" style={{ paddingTop: 20 }}>
      <Box sx={{ marginBottom: 4 }}>
        <ViewField dataObject={poolOverviewCTO} fieldSchema={PoolFlexOverviewCTOSchema.describe().fields.name} />
      </Box>

      <Button
        disabled={isSubmitted}
        sx={sx}
        onClick={() => {
          handleDailyAccrual()
        }}
        variant={'contained'}
      >
        <Typography variant={'buttonBold'}>Do Daily Accrual</Typography>
      </Button>
    </div>
  )
}
